import { toItem } from '../mappers/item';
export function parseItems(res) {
  const {
    photos = [],
    limit,
    offset
  } = res.data;
  const hasMore = photos.length === limit;
  const cursor = hasMore ? offset + limit : null;
  res.data = photos.map(item => ({
    ...toItem(item),
    hasMoreItemsInThisCategory: cursor !== null
  }));
  res.paging = {
    cursor,
    size: limit
  };
  return res;
}